import { render, staticRenderFns } from "./SelectQuestionDialog.vue?vue&type=template&id=2092bd1c&"
import script from "./SelectQuestionDialog.vue?vue&type=script&lang=js&"
export * from "./SelectQuestionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports